module.exports = __webpack_public_path__ + "img/f23e81a.png";